import { render, staticRenderFns } from "./meeting-room.vue?vue&type=template&id=216aaf68&"
import script from "./meeting-room.vue?vue&type=script&lang=js&"
export * from "./meeting-room.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports